import script from "./AdditionStockWarning.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdditionStockWarning.vue?vue&type=script&lang=ts&setup=true"

import "./AdditionStockWarning.vue?vue&type=style&index=0&id=4dbb0732&lang=scss&scope=true"
import "./AdditionStockWarning.vue?vue&type=style&index=1&id=4dbb0732&lang=scss"

const __exports__ = script;

export default __exports__